module.exports = __webpack_public_path__ + "static/media/courses.9a833480.svg";